const LABELS = [
  { match: ["hybrid", "lataus"], label: "Hybridi" },
  { match: ["sähk", "sahk", "electr"], label: "Sähkö" },
  { match: ["diesel"], label: "Diesel" },
  { match: ["bensi", "petrol"], label: "Bensiini" },
  { match: ["kaasu", "gas"], label: "Kaasu" },
];

export default function FuelBadge({ fuel, className = "" }) {
  if (!fuel) return null;
  const f = fuel.toLowerCase();
  const style = LABELS.find((s) => s.match.some((m) => f.includes(m)));
  const label = style ? style.label : fuel;
  return (
    <span
      data-testid="fuel-badge"
      className={`inline-block font-mono text-[10px] uppercase tracking-widest text-white/70 border border-white/20 px-3 py-1 ${className}`}
    >
      {label}
    </span>
  );
}
